<template>
    <footer class="footer has-cards">
<!--
        <div class="container container-lg">
            <div class="row">
                <div class="col-md-6 mb-5 mb-md-0">
                    <div class="card card-lift&#45;&#45;hover shadow border-0">
                        <router-link to="/landing" title="Landing Page">
                            <img v-lazy="'img/theme/landing.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-6 mb-5 mb-lg-0">
                    <div class="card card-lift&#45;&#45;hover shadow border-0">
                        <router-link to="/profile" title="Profile Page">
                            <img v-lazy="'img/theme/profile.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
-->
        <div class="container">
<!--
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">از حمایت شما سپاسگزاریم!</h3>
                    <h4 class="mb-0 font-weight-light">گروه کامپیوتر و تکنولوژی سامینتک</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href="https://t.me/MySafeNote"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Join our channel">
                        <i class="fa fa-telegram"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.instagram.com/moradix96"
                       class="btn btn-neutral btn-icon-only btn-instagram btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://samiantec.ir"
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Visit us">
                        <i class="fa fa-globe"></i>
                    </a>
                </div>
            </div>
-->
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                      تمامی حقوق برای <a href="https://samiantec.ir" target="_blank" rel="noopener">سامینتک</a> و <a href="https://moradis.ir" target="_blank" rel="noopener">سینا مرادی</a> محفوظ است.
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item">
                            <a href="https://samiantec.ir" class="nav-link" target="_blank" rel="noopener">سامینتک</a>
                        </li>
                        <li class="nav-item">
                            <a href="https://samiantec.ir/aboutus/" class="nav-link" target="_blank" rel="noopener">درباره ما</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style scoped>
/*.btn-icon-only{
  margin: 0;
}*/
</style>
